import { useState } from "react";

export const Inicio = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const handleClose = () => setMenuOpen(false);

    return (
        <>
            <div className="container flex items-center justify-between px-6 py-4 relative z-50">
                <div className="flex items-center gap-4">
                    <img src="/img/logo.png" alt="Logo" className="h-8" />

                    <nav className="hidden md:flex gap-4 text-sm text-gray-600 items-center">
                        <a href="#inicio" className="hover:text-green-600 transition">Início</a>
                        <a href="#sobre" className="hover:text-green-600 transition">Sobre</a>
                        <a href="#como-funciona" className="hover:text-green-600 transition">Como funciona</a>
                        <a href="#duvidas" className="hover:text-green-600 transition">Dúvidas</a>
                        <a href="#contato" className="hover:text-green-600 transition">Contato</a>

                        <div className="flex gap-2 ml-4">
                            <a href="https://www.facebook.com/share/174BDPc4hA/ " target="_blank" rel="noopener noreferrer">
                                <img src="/img/facebook.png" alt="Facebook" className="h-6 w-6" />
                            </a>
                            <a href="https://www.instagram.com/anilhasalianca?igsh=N3F1czYya3Z6Mnls" target="_blank" rel="noopener noreferrer">
                                <img src="/img/instagram.png" alt="Instagram" className="h-6 w-6" />
                            </a>
                        </div>
                    </nav>
                </div>

                <button
                    className="md:hidden text-gray-600 focus:outline-none z-50"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <svg
                        className="h-6 w-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                        />
                    </svg>
                </button>
            </div>

            {menuOpen && (
                <div
                    className="fixed inset-0 bg-white/30 backdrop-blur-md flex flex-col items-center justify-center gap-6 md:hidden z-40 transition-opacity duration-300"
                    onClick={handleClose}
                >
                    <div
                        className="flex flex-col items-center gap-4 text-lg text-gray-800"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {["#inicio", "#sobre", "#como-funciona", "#duvidas", "#contato"].map((href, i) => (
                            <a
                                key={href}
                                href={href}
                                onClick={handleClose}
                                className="hover:text-green-600 transition"
                            >
                                {["Início", "Sobre", "Como funciona", "Dúvidas", "Contato"][i]}
                            </a>
                        ))}

                        <div className="flex gap-4 mt-4">
                            <a href="https://www.facebook.com/share/174BDPc4hA/ " target="_blank" rel="noopener noreferrer">
                                <div className="bg-white p-2 rounded-full shadow">
                                    <img src="/img/facebook.png" alt="Facebook" className="h-5 w-5" />
                                </div>
                            </a>
                            <a href="https://www.instagram.com/anilhasalianca?igsh=N3F1czYya3Z6Mnls" target="_blank" rel="noopener noreferrer">
                                <div className="bg-white p-2 rounded-full shadow">
                                    <img src="/img/instagram.png" alt="Instagram" className="h-5 w-5" />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
